import { navigate } from '@reach/router'
import { call, put, takeLatest } from 'redux-saga/effects'

// redux
import * as terminationsApi from '../apiModules/terminations'
import * as terminationsModule from '../modules/terminations'

function* terminateParticipant({ payload }) {
  try {
    yield call(terminationsApi.terminateParticipant, payload)
    yield put(terminationsModule.terminateParticipantSuccess())

    const workspaceParam = payload.workspace_id ? `workspaceId=${payload.workspace_id}` : ''
    navigate(`/dashboard/participants?terminatedParticipant=success&${workspaceParam}`)
  } catch (err) {
    yield put(terminationsModule.terminateParticipantFailure(err.response.data))
  }
}

function* bulkTerminateParticipants({ payload }) {
  try {
    yield call(terminationsApi.bulkTerminateParticipants, payload)
    yield put(terminationsModule.bulkTerminateParticipantsSuccess())

    const workspaceParam = payload.workspace_id ? `workspaceId=${payload.workspace_id}` : ''
    navigate(`/dashboard/participants?terminatedParticipants=success&${workspaceParam}`)
  } catch (err) {
    yield put(terminationsModule.bulkTerminateParticipantsFailure(err.response.data))
  }
}

export const terminationsSagas = [
  takeLatest(terminationsModule.TERMINATE_PARTICIPANT, terminateParticipant),
  takeLatest(terminationsModule.BULK_TERMINATE_PARTICIPANTS, bulkTerminateParticipants)
]
